<template>
  <div id="app">
    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.6.3/css/all.css">

    <site-header />

    <div class="site-content">
      <router-view/>
    </div>

    <site-footer/>
  </div>
</template>

<script>
import SiteHeader from "@/components/SiteHeader.vue";
import SiteFooter from "@/components/SiteFooter.vue";

export default {
  name: "app",
  components: {
    SiteHeader,
    SiteFooter
  },
};
</script>

<style lang="scss">
@import '/styles/global.scss';
// @import '/styles/animation.scss';
</style>
